module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dialogSubscription.title":"Subscriptions","views.dialogSubscription.tabs.usage":"Usage","views.dialogSubscription.tabs.carbon":"Emissions","views.dialogSubscription.tabs.trends":"Trends","views.dialogSubscription.tabs.virtualtags":"Virtual Tags","views.dialogSubscription.tabs.annotations":"Annotations"}}')
  delete Component.options._Ctor
}
